import { useCallback } from 'react';
import cross from '~/assets/icons/cross.svg';
import success from '~/assets/icons/success.svg';
import {
	Button,
	ButtonBorderRadius,
	ButtonColors,
	ButtonHeight,
} from '~/components/ui/Button';
import { Text } from '~/components/ui/Text';
import {
	setAuctionDoneVisible,
	setItemAuctionPageVisible,
	useLayoutDispatch,
} from '../../redux';
import {
	StyledContainer,
	StyledCrossWrap,
	StyledPrimaryButtonWrap,
	StyledShadow,
} from './AppAuctionDoneScreen.styled';

const AppAuctionDoneScreen = () => {
	const dispatch = useLayoutDispatch();

	const handleOpenLot = useCallback(() => {
		dispatch(setAuctionDoneVisible(false));
		dispatch(setItemAuctionPageVisible(true));
	}, [dispatch]);

	const handleClose = useCallback(() => {
		dispatch(setAuctionDoneVisible(false));
	}, [dispatch]);

	return (
		<StyledContainer>
			<StyledShadow />
			<img src={success} />
			<Text>Ваш аукцион успешно опубликован!</Text>
			<StyledPrimaryButtonWrap>
				<Button
					color={ButtonColors.Select2}
					height={ButtonHeight.Height40}
					onClick={handleOpenLot}
					style={{ minWidth: 160 }}
				>
					<Text style={{ fontSize: 14 }}>Открыть страницу</Text>
				</Button>
			</StyledPrimaryButtonWrap>
			<StyledCrossWrap>
				<Button
					color={ButtonColors.Default}
					height={ButtonHeight.Height40}
					borderRadius={ButtonBorderRadius.Radius10}
					square
					onClick={handleClose}
				>
					<img width={14} height={14} src={cross} alt="" />
				</Button>
			</StyledCrossWrap>
		</StyledContainer>
	);
};

export { AppAuctionDoneScreen };
